import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function NewTopic() {
  const [categories, setCategories] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    category: location.state?.category || "",
    title: "",
    body: "",
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/categories").then(({ data }) => {
      setCategories(data);
      if (!form.category && data.length) setForm((f) => ({ ...f, category: data[0].slug }));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/topics", form);
      toast.success("Konu açıldı");
      navigate(`/topic/${data.topic_id}`);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Konu oluşturulamadı");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="k-container py-12 md:py-16">
      <div className="mx-auto max-w-2xl">
        <h1 className="font-display text-5xl text-ink-900" data-testid="new-topic-title">
          Yeni bir konu aç
        </h1>
        <p className="mt-2 font-body text-ink-700">
          Yavaşça yaz. Sorularla, hikâyelerle, tereddütlerle gel.
        </p>

        <form onSubmit={submit} className="k-card mt-8 space-y-5 p-8" data-testid="new-topic-form">
          <div>
            <label className="k-label">Kategori</label>
            <select
              className="k-input"
              value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
              data-testid="new-topic-category"
            >
              {categories.map((c) => (
                <option key={c.slug} value={c.slug}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="k-label">Başlık</label>
            <input
              className="k-input"
              minLength={3}
              maxLength={140}
              required
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              data-testid="new-topic-title-input"
            />
          </div>
          <div>
            <label className="k-label">İçerik</label>
            <textarea
              rows={8}
              className="k-input resize-none"
              required
              value={form.body}
              onChange={(e) => setForm({ ...form, body: e.target.value })}
              placeholder="Ne düşünüyorsun?"
              data-testid="new-topic-body-input"
            />
          </div>

          {error && (
            <div className="rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
              {error}
            </div>
          )}

          <button type="submit" disabled={busy} className="k-btn-primary" data-testid="new-topic-submit">
            {busy ? "Gönderiliyor…" : "Konuyu paylaş"}
          </button>
        </form>
      </div>
    </div>
  );
}
